var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSizerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_745_5940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66232 7.43451C8.3499 7.12209 7.84336 7.12209 7.53095 7.43451C7.21853 7.74693 7.21853 8.25346 7.53095 8.56588L10.9653 12.0002L7.43427 15.5312C7.12185 15.8436 7.12185 16.3501 7.43427 16.6626C7.74669 16.975 8.25322 16.975 8.56564 16.6626L12.0966 13.1316L15.5309 16.5659C15.8434 16.8783 16.3499 16.8783 16.6623 16.5659C16.9747 16.2535 16.9747 15.7469 16.6623 15.4345L13.228 12.0002L16.5656 8.66256C16.8781 8.35014 16.8781 7.84361 16.5656 7.53119C16.2532 7.21877 15.7467 7.21877 15.4343 7.53119L12.0966 10.8688L8.66232 7.43451Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_745_5940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizerClose);
export default __webpack_public_path__ + "static/media/sizerClose.1739f30c.svg";
export { ForwardRef as ReactComponent };